var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Clan-flag"},[_c('img',{class:_vm.tag ? 'Clan--found' : 'Clan--unknown',style:('width:  ' + _vm.size + 'px;' +
            'height: ' + _vm.size + 'px;'),attrs:{"src":_vm.tag ? '/assets/icons/clan.png' : '/assets/icons/noclan.png'}})])}
var staticRenderFns = []

export { render, staticRenderFns }